.leftbar {
  background: #fff;
  flex-direction: column;
  align-items: center;
  width: 60px;
  height: 100vh;
  padding: 15px 0;
  display: flex;
  position: fixed;
  left: 0;
  justify-content: center;
  z-index: 99999;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: 15px;
  svg {
    color: #aaa;
    margin-left: 2px;
  }
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nav-icons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.nav-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #aaa;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-item:hover {
  background: #f1f1f1;
}

.nav-item.active {
  color: black;
  fill: black!important;
  svg {
    fill: black!important;
  }
}

@media screen and (max-width: 945px) {
  .leftbar {
    height: 60px;
    width: 100%;
    bottom: 0;
    flex-direction: row;
  }

  .nav-icons {
    flex-direction: row;
  }

  .nav-item {
    margin-top: 0;
  }

  .avatar {
    margin-left: 15px;
  }
}